import type { ITheme } from '../../../utils/theme';

export const getStyledSelectLabelColor = (hasError: boolean, theme: ITheme) => {
  if (hasError) return theme.palette.error.main;
  return theme.palette.neutral['100'];
};
